export class ProfileSpecialty {
  public createdAt?: Date;
  public updatedAt?: Date;
  public dataSource?: string;
  public type?: string;
  public name: string;
  public slug: string;
  public token: string;
}
